// comprobar que usuario es administrador
export const checkIfAdmin = (privileges) => {
    return privileges.includes('admin');
};